import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InfiniteScroll } from 'common/components';
import { BackBtn } from 'common/components/BackBtn';
import { ERoute } from 'common/const/route.enum';
import { useAppSelector } from 'app/store/store.hooks';
import { ReactComponent as SettingsIcon } from 'app/assets/images/redesign/settings.svg';
import { SettingsSidebarSubdivisionTree } from 'entities/Settings/components/SettingsSidebarSubdivisionTree';
import { SettingsSidebarContractList } from 'entities/Settings/components/SettingsSidebarContractList';
import { ESettingsMenuTab, ESettingsTab } from 'entities/Settings/Settings.enum';
import { selectIsSidebarOpen } from 'entities/UI/UI.slice';

interface IComponentProps {
  isSeller?: boolean;
  isAccountAdmin?: boolean;
}

export const SettingsSidebar: FC<IComponentProps> = ({ isSeller, isAccountAdmin }) => {
  // ui
  const isSidebarOpen = useAppSelector(selectIsSidebarOpen);

  const { tab } = useParams();
  const navigate = useNavigate();

  const isAccountSettings = tab === ESettingsTab.Account;

  return (
    <div className={`flex direction-column settings-sidebar ${isSidebarOpen ? 'collapsed' : ''}`}>
      <InfiniteScroll>
        <div className="mb-11">
          <BackBtn />
        </div>

        {isAccountAdmin && (
          <div
            style={{ cursor: 'pointer' }}
            className={`settings-sidebar__btn hover ${isAccountSettings ? 'active' : ''}`}
            onClick={() =>
              navigate(
                `${ERoute.Settings}/${ESettingsTab.Account}/${isSeller ? ESettingsMenuTab.UserList : ESettingsMenuTab.Contracts}`,
              )
            }
          >
            <div className="settings-sidebar__btn-container">
              <SettingsIcon className="icon-settings-dark-grey" />

              <span className="text-h4-item-name color-black settings-sidebar__btn-text">Настройки аккаунта</span>
            </div>

            <span className="text-tag color-dark-grey settings-sidebar__btn-text">
              {isSeller ? 'Склады отгрузки, скидки и другие настройки' : 'Контракты, пользователи и другие настройки'}
            </span>
          </div>
        )}

        {isSeller ? (
          <SettingsSidebarContractList active={!isAccountSettings} isAccountAdmin={isAccountAdmin} />
        ) : (
          <SettingsSidebarSubdivisionTree active={!isAccountSettings} />
        )}
      </InfiniteScroll>
    </div>
  );
};
